import * as React from "react";
import { Region } from "../../data/types";
import { Box } from "../../shared";
import DropDownMenu from "./DropDownMenu";
import DropDownMenuItem from "./DropDownMenuItem";
import DropDownTrigger from "./DropDownTrigger";

// regions
const Regions = ["All", "Africa", "Americas", "Asia", "Europe", "Oceania"];

interface SelectProps {
  onChangeRegion: (region: Region) => void;
  currentRegion: Region;
}

const DropDown: React.FC<SelectProps> = ({ onChangeRegion, currentRegion }) => {
  const [isOpen, setIsOpen] = React.useState(false);

  const handleIsOpen = () => {
    setIsOpen(!isOpen);
  };

  const handleChangeRegion = (region: Region) => {
    onChangeRegion(region);
  };

  return (
    <Box css={{ position: "relative", mt: "$3", color: "$secondary" }}>
      <DropDownTrigger isOpen={isOpen} handleIsOpen={handleIsOpen} currentRegion={currentRegion} />
      <DropDownMenu isOpen={isOpen}>
        {Regions.map((region, index) => (
          <DropDownMenuItem
            key={index}
            region={region}
            handleIsOpen={handleIsOpen}
            handleChangeRegion={handleChangeRegion}
          />
        ))}
      </DropDownMenu>
    </Box>
  );
};

export default DropDown;
